"use client";

import { useSyncExternalStore } from "react";
import { MOBILE_MAX_WIDTH } from "@/config/constants";

const QUERY = `(max-width: ${MOBILE_MAX_WIDTH - 1}px)`;

/**
 * Whether the viewport is narrow enough for the mobile layout.
 *
 * The legacy app answered this by reading `window.innerWidth` on every `resize`
 * and passing the result down through `MobileContext`. A media query is both
 * cheaper (the browser notifies only on the breakpoint crossing, not on every
 * pixel) and doesn't need a provider — which matters here because this is a
 * viewport fact, not app state, and several unrelated trees need it.
 *
 * `useSyncExternalStore`'s server snapshot is `false`: the server can't know the
 * viewport, and rendering the desktop tree first matches what the CSS does. The
 * real value arrives on the first client render, before paint.
 */
function subscribe(onChange: () => void): () => void {
  const list = window.matchMedia(QUERY);
  list.addEventListener("change", onChange);
  return () => list.removeEventListener("change", onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
